import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, UserRole } from '../auth/AuthContext';
import { Spinner } from './ui/Spinner';

interface Props {
  children: React.ReactNode;
  roles?: UserRole[];
}

export const RequireAuth = ({ children, roles }: Props) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-slate-500">
        <Spinner />
        <span className="text-sm">Vérification de l’accès…</span>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="auth-panel p-8 text-center max-w-md mx-auto mt-4">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-slate-900">Accès refusé</h2>
        <p className="text-slate-600 mt-2 text-sm">
          Cette page est réservée aux rôles : <span className="font-medium">{roles.join(', ')}</span>.
        </p>
      </div>
    );
  }
  return <>{children}</>;
};
